// extracted by mini-css-extract-plugin
export var required = "_ij-0";